import { render } from "./kf-index.vue?vue&type=template&id=146dd36a&scoped=true"
import script from "./kf-index.vue?vue&type=script&lang=js"
export * from "./kf-index.vue?vue&type=script&lang=js"

import "./kf-index.vue?vue&type=style&index=0&id=146dd36a&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146dd36a"]])

export default __exports__